export function Loading({ label = "Carregando..." }) {
    return (
        <div className="w-full">
            <div className="text-center py-10">
                <i className="fas fa-spinner fa-spin text-3xl text-primary/70 mb-4" />
                <p className="text-sm text-muted-foreground animate-pulse">
                    {label}
                </p>
            </div>
        </div>
    )
}